const VERDICT_STYLE = {
	PASS: "bg-green-50 text-green-700",
	FAIL: "bg-red-50 text-red-700",
	UNABLE_TO_VERIFY: "bg-amber-50 text-amber-800",
};

const VERDICT_LABEL = {
	PASS: "Pass",
	FAIL: "Fail",
	UNABLE_TO_VERIFY: "Unable to verify",
};

const ReviewSummary = ({ verdict, passedCount, totalCount, dateLabel, requestedBy }) => (
	<div className="relative mb-3 bg-white text-stone-800">
		<p className="flex items-center gap-2 text-xl font-semibold">
			<span className={`rounded px-2 py-0.5 text-base font-semibold ${VERDICT_STYLE[verdict] || "bg-stone-100 text-stone-700"}`}>
				{VERDICT_LABEL[verdict] || "Review"}
			</span>
			<span>{passedCount}/{totalCount}</span>
		</p>
		{requestedBy ? <p className="mt-1 text-base text-stone-700">Requested by {requestedBy}</p> : null}
		{dateLabel ? <p className="text-base text-stone-500">{dateLabel}</p> : null}
	</div>
);

export default ReviewSummary;
